document.addEventListener('DOMContentLoaded', function() {
  const videoContainers = document.querySelectorAll('.autoplay-video-section .video-container');
  const observerOptions = { root: null, rootMargin: '0px', threshold: 0.5 };
  
  function setupAudioToggle(container) {
    const button = container.querySelector('.audio-toggle-btn');
    if (!button) return;
    
    const video = container.querySelector('video');
    const iframe = container.querySelector('iframe');
    const mutedIcon = button.querySelector('.icon-muted');
    const unmutedIcon = button.querySelector('.icon-unmuted');
    
    // Prevent multiple event listeners on the same button
    if (button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isMuted = button.getAttribute('data-muted') === 'true';
      
      if (video) {
        video.muted = !isMuted;
        button.setAttribute('data-muted', !isMuted);
        mutedIcon.style.display = isMuted ? 'none' : 'block';
        unmutedIcon.style.display = isMuted ? 'block' : 'none';
      } else if (iframe) {
        const src = iframe.src;
        
        // YouTube API
        if (src.includes('youtube.com')) {
          const message = isMuted 
            ? '{"event":"command","func":"unMute","args":""}' 
            : '{"event":"command","func":"mute","args":""}';
          iframe.contentWindow.postMessage(message, '*');
        } 
        // Vimeo API
        else if (src.includes('vimeo.com')) {
          const message = isMuted 
            ? '{"method":"setVolume","value":1}' 
            : '{"method":"setVolume","value":0}';
          iframe.contentWindow.postMessage(message, '*');
        }
        
        button.setAttribute('data-muted', !isMuted);
        mutedIcon.style.display = isMuted ? 'none' : 'block';
        unmutedIcon.style.display = isMuted ? 'block' : 'none';
      }
    });
    
    // Wait for iframe API to be ready
    if (iframe) {
      iframe.addEventListener('load', function() {
        setTimeout(() => {
          // Enable YouTube API
          if (iframe.src.includes('youtube.com')) {
            iframe.contentWindow.postMessage('{"event":"listening"}', '*');
          }
        }, 100);
      });
    }
  }
  
  const handleIntersection = (entries) => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('video');
      const iframe = entry.target.querySelector('iframe');
      
      if (entry.isIntersecting) {
        if (video) {
          video.play().catch(err => console.log('Autoplay blocked:', err));
        } else if (iframe) {
          const src = iframe.src;
          if (src.includes('youtube.com')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (src.includes('vimeo.com')) {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }
      } else {
        if (video) {
          video.pause();
        } else if (iframe) {
          const src = iframe.src;
          if (src.includes('youtube.com')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (src.includes('vimeo.com')) {
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      }
    });
  };
  
  const observer = new IntersectionObserver(handleIntersection, observerOptions);
  
  videoContainers.forEach(container => {
    setupAudioToggle(container);
    observer.observe(container);
  });
});